import { render } from "./AppRun.vue?vue&type=template&id=64a4c8ff&scoped=true"
import script from "./AppRun.vue?vue&type=script&lang=js"
export * from "./AppRun.vue?vue&type=script&lang=js"

import "./AppRun.vue?vue&type=style&index=0&id=64a4c8ff&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-64a4c8ff"

export default script